import { FilmDetailsComponentPropsApi } from './models'
import { FilmDetailsProps } from '@vista-digital/occ-ui'
import { defaultFilmDetailsProps } from '@vista-digital/occ-ui/src/lib/components/film/details/types/props'
import { MovioTracker } from '../../utilities'

export function getFilmDetailsProps(data: FilmDetailsComponentPropsApi): FilmDetailsProps {
    const movioTracker = new MovioTracker()

    return {
        ...defaultFilmDetailsProps,
        displayText: {
            ...data,
        },
        events: {
            onPlayTrailerButtonClicked: film => {
                movioTracker.movieTrailer(film.id)
            },
            onFilmAddedToWatchlist: film => {
                movioTracker.movieWatchList(film.id, false)
            },
            onFilmRemovedFromWatchlist: film => {
                movioTracker.movieWatchList(film.id, true)
            },
        },
    }
}
